import { useScenarioStore } from '../../store/scenarioStore';
import { useStressTestStore } from '../../store/stressTestStore';
import { useNetworkUIStore } from '../../store/networkUIStore';
import { MEASURE_KIND_LABELS, measureValueLabel } from '../../utils/planningLabels';

/** Pending grid measures of the scenario (cable type, fuse rating, transformer rating, tap / rONT setpoint). */
export function MeasuresCard() {
  const measures = useScenarioStore(s => s.pendingMeasures);
  const removeMeasure = useScenarioStore(s => s.removeMeasure);
  const stressElements = useStressTestStore(s => s.stressElements);
  const unit = useStressTestStore(s => s.unit);
  const setSelectedElement = useNetworkUIStore(s => s.setSelectedElement);

  if (measures.length === 0) return null;

  const nameOf = (id: string) => stressElements.find(e => e.id === id)?.name ?? unit?.couplings.find(c => c.id === id)?.name ?? id;
  const select = (id: string) => {
    const el = stressElements.find(e => e.id === id);
    if (el) setSelectedElement(el);
  };

  return (
    <div className="rounded-lg border border-orange-300 dark:border-orange-600 bg-white dark:bg-primary-700 overflow-hidden">
      <div className="px-3 py-2.5">
        <h3 className="text-xs font-semibold uppercase tracking-wider text-gray-800 dark:text-primary-100 mb-1.5">
          Maßnahmen <span className="text-gray-400 dark:text-primary-400 font-normal">({measures.length})</span>
        </h3>
        <ul className="divide-y divide-gray-100 dark:divide-primary-600">
          {measures.map(m => (
            <li key={m.id} className="py-1.5 flex items-center gap-2">
              <button type="button" onClick={() => select(m.elementId)} className="flex-1 min-w-0 text-left">
                <span className="block text-xs text-gray-800 dark:text-primary-100 truncate">
                  {MEASURE_KIND_LABELS[m.kind] ?? m.kind} · {nameOf(m.elementId)}
                </span>
                <span className="block text-[10px] text-gray-500 dark:text-primary-400">
                  {measureValueLabel(m)}
                </span>
              </button>
              <button type="button" onClick={() => removeMeasure(m.id)} title="Maßnahme entfernen" className="shrink-0 p-1 text-gray-400 hover:text-red-600 dark:hover:text-red-400">×</button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
